import styled from "styled-components";

const Container = styled.div`
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;

    @media (max-width: 991px) {
        width: 960px;
    }
    @media (max-width: 767px) {
        width: 720px;
    }
    @media (max-width: 575px) {
        width: 100%;
    }
`;
export default Container;
